import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "../../../Setting/common/styled"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"

const FilterOut = ({ setFilter, setKeyword }) => {
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current || ""
    setKeyword(keyword)
  }
  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        {/* <Input placeholder="Số lô nhập" style={{ width: 130 }} />
        <Input placeholder="Mã xuất kho" style={{ width: 130 }} /> */}
        {/* <SelectProvider
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, supplier_id: val }))}
        />
        <SelectCarrier
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, network_id: val }))}
        /> */}
        <SelectCustomer 
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, customer_id: val }))}
        />
        {/* <Select
          placeholder={
            <span style={{ color: "#bfbfbf", fontWeight: 380 }}>
              Trạng thái
            </span>
          }
          allowClear
          style={{ width: 150 }}
        >
          <Select.Option value="new">Mới nhập</Select.Option>
          <Select.Option value="used">Đã sử dụng</Select.Option>
          <Select.Option value="cancel">Hủy</Select.Option>
        </Select> */}

        <CustomRangePicker
          style={{ width: 250 }}
          format="DD/MM/YYYY"
          onChange={dates => {
            if (dates) {
              const [start, end] = dates
              setFilter(prev => ({
                ...prev,
                start_date: start ? start.format("YYYY-MM-DD") : undefined,
                end_date: end ? end.format("YYYY-MM-DD") : undefined,
              }))
            } else {
              setFilter(prev => ({
                ...prev,
                start_date: undefined,
                end_date: undefined,
              }))
            }
          }}
        />
      </div>
      <div>
        <InputSearchStyle>
          <Input
            allowClear
            className="custom-input"
            maxLength={50}
            placeholder="Tìm kiếm theo mã đơn hàng"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
            size="small"
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" onClick={onSearch} />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterOut
